import { render, staticRenderFns } from "./DecisionNavigation.vue?vue&type=template&id=6a7454ae&scoped=true"
import script from "./DecisionNavigation.vue?vue&type=script&lang=ts"
export * from "./DecisionNavigation.vue?vue&type=script&lang=ts"
import style0 from "./DecisionNavigation.vue?vue&type=style&index=0&id=6a7454ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7454ae",
  null
  
)

export default component.exports